import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Liner, AirLine, AirLineService, OceanLineService, OceanLine, Line } from 'app/services';


export class SelectedLine {
  lineCd: string;
  lineNm: string;
}

@Component({
  selector: 'line-selector',
  templateUrl: 'line-selector.html'
})
export class LineSelectorComponent {
  @Input() type: string = 'ocean';
  @Input() lineCd: string;
  @Input() lineNm: string;
  @Input() lineList: Array<any>;
  @Input() savedLine: Line;
  @Output() onSelect: EventEmitter<SelectedLine> = new EventEmitter ();
  
  oceanLineList: OceanLine[] = [];
  airLineList: AirLine[] = [];

  showDropDown: boolean = false;
  showAutoList: boolean = false;

  suggestList: Array<any> = [];

  linerControl: FormControl = new FormControl();

  focusedIndex: number = 0;
  selectedLine: SelectedLine = new SelectedLine();

  @ViewChild("suggestListRef")
  suggestListElRef: ElementRef;
  
  constructor(
    private airLineService: AirLineService,
    private oceanLineService: OceanLineService,
  ) {}

  ngOnInit() {
    this.oceanLineList = this.oceanLineService.lineList;

    if(_.isEmpty(this.oceanLineList)) {
      this.oceanLineService.lineListEe.subscribe(
        oceanLineList => {
          this.oceanLineList = oceanLineList;
        }
      );
    }

    this.airLineList = this.airLineService.lineList;
    
    this.airLineService.lineListEe.subscribe(
      airLineList => {
        this.airLineList = airLineList;
      }
    );
  }

  ngOnChanges(changes:SimpleChanges) {
    if(this.lineCd != null && this.lineNm != null) {
      this.linerControl.setValue('[' + this.lineCd + '] ' + this.lineNm);
    }
    if(!_.isEmpty(this.lineList)) {
      if(this.type == 'ocean') {
        this.oceanLineList = _.filter(this.oceanLineList, (v) => _.includes(this.lineList, v.lineCd));
      } else {
        this.airLineList = _.filter(this.airLineList, (v) => _.includes(this.lineList, v.iataCd));
      }
    }

    if(changes.savedLine) {
      if(this.savedLine) {
        this.linerControl.setValue('[' + this.savedLine.lineCd + '] ' + this.savedLine.lineNm);
      } else {
        this.linerControl.setValue('');
      }
    }
  }


  clickOutside() {
    if (this.showDropDown || (this.suggestList && this.suggestList.length > 0)) {
      this.clearLiner();
    } else {
      this.showDropDown =  false;
      this.showAutoList = false;
    }
  }

  clearLiner() {
    if(this.selectedLine) {
      this.showDropDown =  false;
      this.suggestList = [];
      this.focusedIndex =  0;
      this.onSelect.emit(null);
      this.linerControl.setValue('');
    }
  }

  handleSuggest(e) {
    let lineList = [];
    
    if(this.type == 'ocean') lineList = this.oceanLineList;
    else lineList = this.airLineList;
    
    let value = e.target.value;
    const inputValue = _.toUpper(value.trim()).replace(/\s/g, '');
    const inputLength = inputValue.length;

    let filteredList = [];
    let codeList = [];
    
    if (inputValue.length > 0) {
      codeList = _.filter(
        lineList,
        (line) => {
          if(this.type == 'ocean') return line.lineCd === inputValue;
          else return line.iataCd  === inputValue;
        }
      );

      filteredList = _.filter(lineList,
                                (line) => {
                                  let lineLabel;
                                  if(this.type == 'ocean') {
                                    lineLabel = _.toUpper(line.lineNm).replace(/\s/g, '');
                                    return line.lineCd != inputValue && lineLabel.indexOf(inputValue) >= 0;
                                  } else {
                                    lineLabel = _.toUpper(line.name).replace(/\s/g, '');
                                    return line.iataCd != inputValue && lineLabel.indexOf(inputValue) >= 0;
                                  }
                                }
                              );
      
      filteredList = _.sortBy(
        filteredList,
        (line) => {
          let lineLabel;
          if(this.type == 'ocean') lineLabel = _.toUpper(line.lineNm).replace(/:/g, 'AAAAAAAAAAA');
          else lineLabel = _.toUpper(line.name).replace(/:/g, 'AAAAAAAAAAA');
          return lineLabel;
        }
      );
      filteredList = _.sortBy(
        filteredList,
        (line) => {
          let lineLabel;
          if(this.type =='ocean') lineLabel = _.toUpper(line.lineNm).replace(/\s/g, '');
          else lineLabel = _.toUpper(line.name).replace(/\s/g, '');
          return _.toUpper(lineLabel).indexOf(inputValue);
        }
      );

      filteredList = codeList.concat(filteredList);
    }

    
    this.showDropDown = false;
    this.showAutoList = false;
    
    this.suggestList = filteredList;
    this.selectedLine = new SelectedLine();
    this.focusedIndex = 0;
    
  }

  handleKeyDown(event) {
    if (event.keyCode !== 9 && event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40) return;
    
    let focusedIndex = this.focusedIndex;
    let suggestListDom = null;
    if(this.suggestListElRef) suggestListDom = this.suggestListElRef.nativeElement;
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');

    let line = this.suggestList[this.focusedIndex];

		switch (event.keyCode) {
      case 9: //tab
        if (line) this.handleSelectLine(line);
        break;
			case 13: // enter
        if (line) this.handleSelectLine(line);
			  break;
			case 27: // escape
				this.clearLiner();
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > this.suggestList.length - 1) focusedIndex = this.suggestList.length - 1;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }
    if(event.keyCode != 9) {
      event.preventDefault();
    }
  }

  handleShowDropDown() {
    this.showDropDown = !this.showDropDown;
  }

  handleSelectLine(liner) {
    if(this.type == 'ocean') {
      this.selectedLine.lineCd = liner.lineCd;
      this.selectedLine.lineNm = liner.lineNm;
    } else {
      this.selectedLine.lineCd = liner.iataCd;
      this.selectedLine.lineNm = liner.name;
    }

    let lineName = '[' + this.selectedLine.lineCd + ']' + this.selectedLine.lineNm;
    this.linerControl.setValue(lineName);

    this.onSelect.emit(this.selectedLine);

    this.showDropDown = false;
    this.suggestList = [];
  }


}


// WEBPACK FOOTER //
// ./src/app/components/selector/line-selector.ts